import { urlSchema } from '../../../schemas/common/url.js';
import { z } from 'zod';
import { addressSchema } from '../../Address.js';
import { logosSchema } from '../../Logos.js';
import { domainsServiceConfigSchema } from '../configurations/DomainsServiceConfig.js';
import { servicesProviderGenericDataSchema, supportObjectSchema, stylingMapSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderDomainsDataSchema = servicesProviderGenericDataSchema.extend({
    config: z.object({
        [Services.DOMAINS]: domainsServiceConfigSchema,
    }),
    analyticsBoardUrl: z.string(),
    support: supportObjectSchema,
    links: z.object({
        aboutUs: urlSchema,
        locations: urlSchema,
        privacyPolicy: urlSchema,
        termsOfService: urlSchema,
        website: urlSchema,
        contact: urlSchema,
    }),
    branding: z.object({
        logos: logosSchema,
        stylingMap: stylingMapSchema,
    }),
    physicalAddress: addressSchema,
});

export { servicesProviderDomainsDataSchema };
//# sourceMappingURL=ServicesProviderDomainsData.js.map
